import { CodePrestation } from './../../services/codes/code-prestation';
import { IMaladieAccident, IGetAllMaladie } from './../../services/agenda/imaladie';
import { MaladieService } from './../../services/agenda/maladie.service';

import { IMaladie } from './interface/imaladie';
import { Prestation } from './../../services/agenda/prestation';
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from '../../services/authentication/auth.service';
import { AlertService } from '../../services/alert.service';
import { ViewBaseComponent } from '../view-base.component';
import { AppGlobals } from '../../app.globals';
import { Personnel } from '../../services/personnel/personnel';
import { PersonnelService } from '../../services/personnel/personnel.service';
import { CodesService } from '../../services/codes/codes.service';
import { MatDialog } from '@angular/material/dialog';
import { ChangeDetectorRef } from '@angular/core';
import { ModifPeriodeDialog } from './modif-periode-dialog.component'


import { Agenda } from '../../services/agenda/agenda';
import { AgendaService } from '../../services/agenda/agenda.service';
import { Occupation } from '../../services/personnel/occupation'
import * as moment from 'moment'
import { AjouterMaladieDialogComponent } from './ajouter-maladie-dialog/ajouter-maladie-dialog.component';

//fontawesome
import {
  faArrowRight,
  faArrowLeft
} from '@fortawesome/free-solid-svg-icons';
import { FormControl } from '@angular/forms';


@Component({
  templateUrl: 'agenda.component.html',
  styleUrls: ['./agenda.component.scss']
})

export class AgendaComponent extends ViewBaseComponent implements OnInit {

  panelOpenState: boolean = false;

  openedPanelPresta: number = -1;

  //fontawesome
  faArrowRight = faArrowRight;
  faArrowLeft = faArrowLeft;

  estDeverrouillable: boolean = false;
  estVerrouiller: boolean = false;
  modification: Boolean = false;
  agendaVerifie: boolean = false;
  clePersonnel: number = 0;
  dateVerifAgenda: Date;
  expend: boolean = true;
  personnel: Personnel[] = [];
  periode = '';
  oldPeriode = '';
  dateAgenda = new Date();
  dateAgendaPicker = new FormControl(new Date());
  agenda: Agenda;
  handle = self;
  maladie: IMaladie[] = [];
  maladiesAccidents: IGetAllMaladie[] = [];
  prestations: Prestation[] = [];
  occupations: Occupation[] = [];
  codesPrestation: CodePrestation[] = [];

  expandPrestationsDuree: boolean = false;
  expandPrestationsDebutFin: boolean = false;
  expandPrestationsValeur: boolean = false;

  options = {
    debut: '08:30',
    repos: '00:00',
    duree: '07:36',
    quantite: 1.0,
    montant: null,
    remplace: true,
  };
  resume = {
    dureeTotaleStr: '',
    dureeTotale: 0,
    dureeTheo: 0,
    dureeHP: '',
    dureeHNP: '',
    jourTotalStr: '',
    jourTotal: 0,
    jourTheo: 0,
    jourHP: 0,
  }
  testcle: number = 0;
  progress: boolean = false;
  resumeBorderClassDuree = '';
  resumeBorderClassJour = '';
  legendExpended = false;
  displayOnHoverCodePrestation: string = "";

  constructor(
    protected authService: AuthService,
    protected alertService: AlertService,
    protected personnelService: PersonnelService,
    private router: Router,
    protected agendaService: AgendaService,
    protected codesService: CodesService,
    private route: ActivatedRoute,
    public dialog: MatDialog,
    private cdRef: ChangeDetectorRef,
    private _maladieService: MaladieService) {
    super(authService, alertService);
  }

  ngOnInit() {

    this.initOptions();
    this.incMonth(-1);

    this.codesService.getCodesPrestation().subscribe(
      codes => {
        this.prestations = [];
        for (let code of codes) {
          this.prestations.push(new Prestation(-1, -1, code.Cle, code.Code, null, this.options.debut, this.options.duree, this.options.repos, this.options.quantite, this.options.montant, code.CleTypeHeureJour, code.Signe, null, code.EncodageHeure, code.CleUnite));
          this.codesPrestation.push(new CodePrestation(code.Cle, code.Code, code.Lib));
        }
      }
    );

    if (this.route.snapshot.params.cle != null) {
      this.clePersonnel = parseInt(this.route.snapshot.params.cle);
      this.onPersoSelected();
    } else {
      this.recalculTotaux();
    }
  }

  recalculTotaux() {
    var dureeHP: number = 0;
    var dureeHNP: number = 0;
    var duree: number = 0;
    var dayWithHP: Boolean = false;

    this.resume.dureeTotale = 0;
    this.resume.dureeTheo = 0;
    this.resume.jourTotal = 0;
    this.resume.jourTheo = 0;
    this.resume.jourHP = 0;

    if (this.agenda != null) {
      for (var sem = 0; sem < this.agenda.Semaines.length; sem++) {
        for (var jour = 0; jour < 7; jour++) {
          dayWithHP = false;
          this.agenda.Semaines[sem].Jours[jour].DureeJour = 0;
          for (let presta of this.agenda.Semaines[sem].Jours[jour].Prestations) {
            if (presta.CodePrestationCleUnite == AppGlobals.CLE_UNITE_HEURE) {
              duree = presta.Signe * AppGlobals.heureToMin(presta.DureeQte);
              this.agenda.Semaines[sem].Jours[jour].DureeJour = this.agenda.Semaines[sem].Jours[jour].DureeJour + duree;
              this.resume.dureeTotale = this.resume.dureeTotale + duree;

              if (presta.TypeHeureJour == AppGlobals.TYPE_HEURE_PRESTE) {
                dureeHP = dureeHP + duree;
                dayWithHP = dayWithHP === true || duree > 0;
              }
              if (presta.TypeHeureJour == AppGlobals.TYPE_HEURE_NON_PRESTE) dureeHNP = dureeHNP + duree;
            }
          }
          if (this.agenda.Semaines[sem].Jours[jour].DureeJour > 0) this.resume.jourTotal = this.resume.jourTotal + 1;

          duree = this.agenda.Semaines[sem].Jours[jour].DureeJourTheo;
          this.resume.dureeTheo = this.resume.dureeTheo + duree;
          if (duree > 0) this.resume.jourTheo = this.resume.jourTheo + 1;
          if (dayWithHP == true) this.resume.jourHP = this.resume.jourHP + 1;
        }
      }
    }
    this.resume.dureeTotaleStr = `${AppGlobals.minToHeure(this.resume.dureeTotale)} / ${AppGlobals.minToHeure(this.resume.dureeTheo)}`;
    this.resume.dureeHP = AppGlobals.minToHeure(dureeHP);
    this.resume.dureeHNP = AppGlobals.minToHeure(dureeHNP);
    this.resume.jourTotalStr = `${this.resume.jourTotal} / ${this.resume.jourTheo}`;
    this.setResumeBorderClass();
  }

  incMonth(inc: number) {
    this.dateAgenda.setDate(1);
    this.dateAgenda.setMonth(this.dateAgenda.getMonth() + inc);
    this.dateAgendaPicker = new FormControl(this.dateAgenda);
    this.periode = `${this.dateAgenda.getMonth() + 1}/${this.dateAgenda.getFullYear()}`;
    if (this.dateAgenda.getMonth() == 0)
      this.oldPeriode = `12/${this.dateAgenda.getFullYear()-1}`;
    else
      this.oldPeriode = `${this.dateAgenda.getMonth()}/${this.dateAgenda.getFullYear()}`;
    if (this.periode.length == 6) this.periode = '0' + this.periode;

    this.progress = true;
    this.personnelService.getPersonnel(this.periode).subscribe(
      personnel => {
        this.personnel = personnel;
        let perso = this.personnel.filter(x => x.Cle == this.clePersonnel);
        if (perso.length == 0) {
          this.clePersonnel = null;
          this.occupations = [];
        }
        this.progress = false;
      }
    );
    this.chargerAgenda(false);
  }

  closeDatePicker(eventData: any, dp?:any) {
    this.dateAgenda.setFullYear(eventData.year(), eventData.month());
    this.incMonth(0);
    dp.close();
  }

  incTrav(inc: number) {
    var i = 0;
    if (this.personnel.length > 0 && this.clePersonnel != null && this.clePersonnel > 0) {
      while (i < this.personnel.length && this.personnel[i].Cle != this.clePersonnel)
        i = i + 1;
      i = i + inc;
      if (i < 0) i = 0;
    }
    if (i >= 0 && i < this.personnel.length) {
      this.clePersonnel = this.personnel[i].Cle;
      this.onPersoSelected();
    }
  }

  onPersoSelected() {
    this.codesService.getMaladie(this.clePersonnel).subscribe({
      next: (maladieData) => {
        this.maladie = maladieData;

      }
    });

    this.chargerOccupations();
    this.chargerAgenda(false);
  }

  chargerAgenda(forceInjection: boolean) {
    this.agenda = null;
    this.isPrestationEmpty();

    if (this.clePersonnel != null && this.clePersonnel > 0) {
      this.progress = true;
      this.agendaService.getAgendaSecretariat(this.clePersonnel, this.periode, forceInjection).subscribe(
        agenda => {

          this.agenda = agenda;
          this.progress = false;
          let avecPointage: boolean = false;
          let avecMaladie: boolean = false;
          agenda.Semaines.forEach(element => {
            element.Jours.forEach(jour => {
              avecPointage = avecPointage || jour.AvecPointage;
              avecMaladie = avecMaladie || jour.AvecMaladie;
            });
          });
          this.estDeverrouillable = avecPointage == false;
          this.agenda.codesPrestation = this.agenda.codesPrestation.concat(this.codesPrestation.filter((item) => this.agenda.codesPrestation.filter((item2) => item.Cle == item2.Cle).length == 0));
          this.agenda.codesPrestation = this.agenda.codesPrestation.sort(function (a, b) { return a.Code < b.Code ? -1 : 1 });
        }
      );

      this.personnelService.getPersonnelByCle(this.clePersonnel).subscribe(
        personnel => {
          this.dateVerifAgenda = personnel != null ? personnel.DateVerifAgenda : null;
          this.agendaVerifie = this.dateVerifAgenda != null && this.dateVerifAgenda >= moment(this.periode + '/01', "MM/YYYY/DD").toDate();
          this.estVerrouiller = this.agendaVerifie;
        }
      );
    }
  }

  chargerOccupations = function () {
    this.occupations = [];
    if (this.clePersonnel != null && this.clePersonnel > 0) {
      this.personnelService.getOccupations(this.clePersonnel, this.periode).subscribe(
        occupations => {
          this.occupations = occupations;
        }
      );
    }
  }

  // Besoin de presta.debut
  onDebutChange() {
    for (let presta of this.prestations) {
      presta.Debut = this.options.debut;
    }
    var cookie = JSON.parse(localStorage.getItem('gapSecretariat'));
    cookie.agenda.options = this.options;
    localStorage.setItem('gapSecretariat', JSON.stringify(cookie));
  }


  onReposChange() {
    for (let presta of this.prestations) {
      presta.Repos = this.options.repos;
    }
    var cookie = JSON.parse(localStorage.getItem('gapSecretariat'));
    cookie.agenda.options = this.options;
    localStorage.setItem('gapSecretariat', JSON.stringify(cookie));
  }

  onDureeChange() {
    for (let presta of this.prestations) {
      presta.DureeQte = this.options.duree;
    }
    var cookie = JSON.parse(localStorage.getItem('gapSecretariat'));
    cookie.agenda.options = this.options;
    localStorage.setItem('gapSecretariat', JSON.stringify(cookie));
  }

  onQuantiteChange() {
    for (let presta of this.prestations) {
      presta.Quantite = this.options.quantite;
    }
    var cookie = JSON.parse(localStorage.getItem('gapSecretariat'));
    cookie.agenda.options = this.options;
    localStorage.setItem('gapSecretariat', JSON.stringify(cookie));
  }

  onMontantChange() {
    for (let presta of this.prestations) {
      presta.MontantPaie = this.options.montant;
    }
    var cookie = JSON.parse(localStorage.getItem('gapSecretariat'));
    cookie.agenda.options = this.options;
    localStorage.setItem('gapSecretariat', JSON.stringify(cookie));
  }

  onRemplaceChange() {
    var cookie = JSON.parse(localStorage.getItem('gapSecretariat'));
    cookie.agenda.options = this.options;
    localStorage.setItem('gapSecretariat', JSON.stringify(cookie));
  }

  verifierAgenda() {
    if (this.clePersonnel != null && this.clePersonnel > 0) {
      this.progress = true;
      if (this.agendaVerifie) {
        this.personnelService.verifierAgenda(this.clePersonnel, this.oldPeriode).subscribe(
          result => {
            this.agendaVerifie = !this.agendaVerifie;
            this.dateVerifAgenda = result.DateVerifAgenda;
            this.progress = false;
          }
        );
      }
      else {
        this.personnelService.verifierAgenda(this.clePersonnel, this.periode).subscribe(
          result => {
            this.agendaVerifie = !this.agendaVerifie;
            this.dateVerifAgenda = result.DateVerifAgenda;
            this.progress = false;
          }
        );
      }
    }
    this.estVerrouiller = !this.estVerrouiller;
  }

  modifierAgenda() {
    this.modification = !this.modification;
  }

  getAgendaStatus() {
    if (this.modification) {
      return "col-md-10"
    }
    else {
      return "max-width-agenda"
    }
  }

  setResumeBorderClass() {
    if (this.resume.dureeTotale == this.resume.dureeTheo) this.resumeBorderClassDuree = 'agenda-resume-total-ok'
    else if (this.resume.dureeTotale < this.resume.dureeTheo) this.resumeBorderClassDuree = 'agenda-resume-total-inf'
    else this.resumeBorderClassDuree = 'agenda-resume-total-sup'

    if (this.resume.jourTotal == this.resume.jourTheo) this.resumeBorderClassJour = 'agenda-resume-total-ok'
    else if (this.resume.jourTotal < this.resume.jourTheo) this.resumeBorderClassJour = 'agenda-resume-total-inf'
    else this.resumeBorderClassJour = 'agenda-resume-total-sup'

    this.cdRef.detectChanges();  // pour ne plus avoir l'erreur ExpressionChangedAfterItHasBeenCheckedError
  }

  initOptions() {
    var cookie = JSON.parse(localStorage.getItem('gapSecretariat'));
    if (cookie == null) {
      cookie = { agenda: { options: this.options } };
      localStorage.setItem('gapSecretariat', JSON.stringify(cookie));
    }
    this.options = cookie.agenda.options;
  }

  ajoutMaladiePeriode() {
    const clePO = AppGlobals.getClePO(this.occupations)
    const cookie = JSON.parse(localStorage.getItem('gapSecretariat'));
    const maladieRef = this.dialog.open(AjouterMaladieDialogComponent, {
      width: '500px',
      disableClose: true,
      data: {
        clePO: clePO,
        occupation: this.occupations,
        maladie: this.maladie,
        cleMaladieAccidentParam: cookie.agenda.options.codeMaladie,
        commentaire: null,
        prolongation: null,
        occupations: this.occupations,
        dateFirstMaladie: null,
        choixPremMaladie: null,
        operation: '1',
        cbDuree: false,
        cbQuantite: false,
        cbMontant: false,
        cbPO: false,
        cbCode: true,
        cbConserverNonPreste: true

      }
    });

    maladieRef.afterClosed().subscribe(result => {
      if (result != null) {
        console.log(result);

        const code = this.maladie.filter(x => x.Code === result.codeMaladie)[0];
        const body: IMaladieAccident = {
          Debut: moment(result.dateDebut).format('YYYYMMDD'),
          Fin: moment(result.dateFin).format('YYYYMMDD'),
          ClePersonnel: this.clePersonnel,
          ClePeriodeOccupation: result.clePO,
          CleMaladieAccidentParam: parseInt(code.Cle),
          Cle: null,
          Commentaire: result.commentaire,
          Prolongation: result.prolongation,
          TypeDateFirstMaladie: result.choixPremMaladie,
          DateFirstMaladie: result.choixPremMaladie === 0 ? moment(result.dateMaladie).format('YYYYMMDD') : null
        }
        cookie.agenda.options.codeMaladie = body.CleMaladieAccidentParam;
        localStorage.setItem('gapSecretariat', JSON.stringify(cookie));

        console.log(body);
        this._maladieService.setMaladie(body)
          .subscribe(
            () => {
              this.chargerAgenda(false)

            }
          );

      }
    });
  }


  modifPeriode() {
    const clePO = AppGlobals.getClePO(this.occupations)
    const cookie = JSON.parse(localStorage.getItem('gapSecretariat'));
    const dialogRef = this.dialog.open(ModifPeriodeDialog, {
      width: '425px',
      disableClose: true,
      data: {
        clePO: clePO,
        code: cookie.agenda.options.code,
        debut: this.options.debut,
        repos: this.options.repos,
        duree: this.options.duree,
        quantite: this.options.quantite,
        montant: this.options.montant,
        codes: this.prestations,
        occupations: this.occupations,
        operation: '2',
        cbDuree: false,
        cbQuantite: false,
        cbMontant: false,
        cbPO: false,
        cbCode: true,
        cbConserverNonPreste: true
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result != null) {
        const code = this.prestations.filter(x => x.CodePrestationCode === result.code)[0];
        const body = {
          Operation: parseInt(result.operation, 10),
          CbPO: result.cbPO,
          ClePeriodeOccupation: result.clePO,
          CbDuree: result.cbDuree,
          Duree: result.duree,
          CbQuantite: result.cbQuantite,
          Quantite: result.quantite,
          CbMontant: result.cbMontant,
          Montant: result.montant,
          CbCode: result.cbCode,
          CleCodePrestation: code.CleCodePrestation,
          DateDebut: moment(result.dateDebut).format('YYYYMMDD'),
          DateFin: moment(result.dateFin).format('YYYYMMDD'),
          ClePersonnel: this.clePersonnel,
          ConserverNonPreste: result.cbConserverNonPreste
        }
        console.log('modif', body)

        this.progress = true;
        var presta = this.prestations.filter(x => x.CleCodePrestation === body.CleCodePrestation)[0];
        if (presta.CodePrestationCleUnite == AppGlobals.CLE_UNITE_HEURE) {
          this.agendaService.modifAgendaHeureParPeriode(body)
            .subscribe(
              () => {
                this.chargerAgenda(false);
                this.progress = false;
              }
            );
        }
        else {
          this.agendaService.modifAgendaValeurParPeriode(body)
            .subscribe(
              () => {
                this.chargerAgenda(false);
                this.progress = false;
              }
            );
        }
      }
    });
  }

  expendLegend() {
    this.legendExpended = !this.legendExpended;
    this.expend = !this.expend;

  }

  isPrestationEmpty() {
    this.prestations.forEach(presta => {
      if (presta.CodePrestationEncodageHeure === 0) {
        this.expandPrestationsDebutFin = true;
      };
      if (presta.CodePrestationEncodageHeure === 1) {
        this.expandPrestationsDuree = true;
      }
      if (presta.CodePrestationEncodageHeure === null) {
        this.expandPrestationsValeur = true;
      }

    });
  }

  getCurrentPrestationLib(cleCode: number, index: number): void {
    const lib: any = this.codesPrestation.filter((x) => x.Cle === cleCode)[0];
    if (lib !== undefined) {
      if (lib.Libelle === null || lib.Libelle === '') {
        this.displayOnHoverCodePrestation = `${lib.Code}`;
      } else {
        this.displayOnHoverCodePrestation = `${lib.Code} - ${lib.Libelle}`;
      }
    }
  }

}
